export const SEARCH_SHOWS = "SEARCH_SHOWS"
export const SET_LOADING = "SET_LOADING"
export const SET_SINGLE_SHOW = "SET_SINGLE_SHOW"
export const CLEAR_SINLGE_SHOW = "CLEAR_SINGLE_SHOW"

export const SET_ALERT = "SET_ALERT"
export const REMOVE_ALERT = "REMOVE_ALERT"